import React from "react";

const SocialMediaLinks = ({ socialItems }) => {
	return (
		<div className='flex justify-start items-center gap-2'>
			{socialItems?.map((item, idx) => (
				<a
					key={idx}
					className=' p-2  rounded-sm bg-slate-200 hover:bg-second_color text-main_color custom-transition'
					href={item?.url}
					target='_blank'
					rel='noreferrer'>
					{item?.icon}
				</a>
			))}
		</div>
	);
};

export default SocialMediaLinks;
